import { Controller } from "stimulus"

export default class extends Controller {
  static values = { confirmMessage: String }

  destroy(event) {
    event.preventDefault()

    if (this.hasConfirmMessageValue && !window.confirm(this.confirmMessageValue)) return

    fetch(this.element.href, {
      method: "DELETE",
      headers: {
        "Accept": "text/html",
        "X-CSRF-Token": this.csrfToken()
      },
      credentials: "same-origin"
    }).then((response) => {
      window.location.assign(response.redirected ? response.url : window.location.href)
    })
  }

  csrfToken() {
    const meta = document.querySelector("meta[name='csrf-token']")
    return meta && meta.content
  }
}
